import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core/';

import { Spacing, Teaser, TermsText } from '../components';
import QuizHeader from './QuizHeader';
import QuizImage from './QuizImage';
import QuizQuestion from './QuizQuestion';
import QuizAnswer from './QuizAnswer';
import SubmitQuiz from './SubmitQuiz';

const baseStyles = () => css``;

const Container = styled('div')(baseStyles);

const termsWrapperBaseStyles = ({ theme }) => css`
  padding: 0 ${theme.spacings.tera};
`;

const TermsWrapper = styled('div')(termsWrapperBaseStyles);

const TimsSkillTest = ({
  gameLocked,
  lockedText,
  lockedImageFilename,
  title,
  text,
  cdnUrl,
  quizImageFilename,
  question,
  answerTitle,
  items,
  selected,
  onSelect,
  isSubmitting,
  btnText,
  btnVarient,
  btnDisabled,
  termsText,
  onSubmit,
}) => (
  <Container>
    <Spacing bottom>
      <QuizHeader title={title} text={text} />
    </Spacing>
    {gameLocked && (
      <Spacing bottom triple>
        <Teaser text={lockedText} cdnUrl={cdnUrl} filename={lockedImageFilename} />
      </Spacing>
    )}
    {!gameLocked && (
      <>
        <Spacing bottom>
          <QuizImage cdnUrl={cdnUrl} filename={quizImageFilename} />
        </Spacing>
        <Spacing bottom>
          <QuizQuestion question={question} />
        </Spacing>
        <Spacing bottom>
          <Spacing sides>
            <QuizAnswer title={answerTitle} items={items} selected={selected} onSelect={onSelect} />
          </Spacing>
        </Spacing>
        <Spacing bottom>
          <TermsWrapper>
            <TermsText text={termsText} />
          </TermsWrapper>
        </Spacing>
        <SubmitQuiz
          isSubmitting={isSubmitting}
          disabled={btnDisabled}
          text={btnText}
          variant={btnVarient}
          selected={selected}
          onSubmit={onSubmit}
        />
      </>
    )}
  </Container>
);

TimsSkillTest.propTypes = {
  gameLocked: PropTypes.bool,
  lockedText: PropTypes.string,
  lockedImageFilename: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  cdnUrl: PropTypes.string,
  quizImageFilename: PropTypes.string,
  question: PropTypes.array,
  answerTitle: PropTypes.string,
  items: PropTypes.array,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  isSubmitting: PropTypes.bool,
  termsText: PropTypes.string,
  btnDisabled: PropTypes.bool,
  btnText: PropTypes.string,
  btnVarient: PropTypes.string,
  onSubmit: PropTypes.func,
};

TimsSkillTest.defaultProps = {
  gameLocked: false,
  lockedImageFilename: 'sticks.svg',
  quizImageFilename: 'hockey-divider.svg',
  btnVarient: 'primary',
};

export default TimsSkillTest;
